/* global axios */
import ApiClient from '../ApiClient';

class AdminConfigAPI extends ApiClient {
  constructor() {
    super('omni/admin_config', { accountScoped: true });
  }

  get(key) {
    return axios.get(`${this.url}/${key}`);
  }
}

export default new AdminConfigAPI();



